import React, { useMemo } from 'react';
import deepmerge from 'deepmerge';
import times from 'lodash/times';
import { NET_WORTH_CHART_BASE_CONFIG } from './NetWorthChartConstants';
import Chart from '../../../CommonComponents/Chart';
import { NetWorthChartEmpty } from './NetWorthChartEmpty';
import { NetWorthChartSeries } from '../../MoneyGuideProTypes';

interface Props {
  data: NetWorthChartSeries[] | null;
}

export const NetWorthChart: React.FC<Props> = ({ data }) => {
  const options = useMemo(() => {
    if (!data) {
      return NET_WORTH_CHART_BASE_CONFIG;
    }

    return deepmerge(NET_WORTH_CHART_BASE_CONFIG, {
      series: data.reduce((acc, series, index) => {
        series.values.forEach(({ value, color, name }) => {
          acc.push({
            name,
            color,
            data: times(data.length).map((_, i) => (i === index ? value : 0)),
          });
        });

        return acc;
      }, [] as { name: string; data: number[]; color: string }[]),
      xAxis: {
        categories: data.map(({ title }) => title),
      },
    });
  }, [data]);

  if (!data) {
    return <NetWorthChartEmpty />;
  }

  return <Chart options={options} />;
};
